module.exports = __webpack_public_path__ + "img/logo.0442edb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1